module.exports = __webpack_public_path__ + "img/diagnostic3.043cccbc.jpg";